export const filters = {
  crowd: {
    isEnabled: true,
    filters: {
      'event^people_count__gte:integer': '',
      'event^stream_id__in:string': null,
    },
  },
};
